import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';

export type SessionConflictDialogResult = 'keep-here' | 'leave';

export interface SessionConflictDialogData {
  readonly device: string | null;
}

@Component({
  selector: 'app-session-conflict-dialog',
  standalone: true,
  imports: [MatDialogModule, MaterialModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 mat-dialog-title>{{ 'auth.sessionConflict.title' | translate }}</h2>
    <mat-dialog-content>
      <p>
        {{ 'auth.sessionConflict.body' | translate: { device: data.device || '—' } }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="ref.close('leave')">
        {{ 'auth.sessionConflict.leave' | translate }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="ref.close('keep-here')">
        {{ 'auth.sessionConflict.keepHere' | translate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class SessionConflictDialogComponent {
  readonly ref =
    inject<MatDialogRef<SessionConflictDialogComponent, SessionConflictDialogResult>>(
      MatDialogRef
    );
  readonly data = inject<SessionConflictDialogData>(MAT_DIALOG_DATA);
}
